export default __webpack_public_path__ + "static/media/koleos-colour-3.8f120d30.jpg";